module.exports = __webpack_public_path__ + "gr.svg?dcc2c8657fa2795dda11f625a3fd5d67";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/gr.svg
// module id = 1387
// module chunks = 0